<template>
  <v-container>
    <v-card min-width="35vw" align="center" justify="center" light outlined>
      <v-card-title style="background-color: #d2d7e1">
        <v-list-item>
          <v-list-item-title>
            <h2>{{ club.name }}'s Batches</h2>
          </v-list-item-title>
          <v-btn v-if="$store.state.desktop" @click="overlayAddBatch = true" class="ml-5">
            Add Batch <v-icon class="ml-2" small>fa-plus</v-icon>
          </v-btn>
          <v-spacer />
          <v-list-item-action>
            <v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-card-title>
      <v-card-text class="pt-3 pb-1">
        <v-container fluid>
          <v-data-table :headers="headers" :items="club.batches">
            <template v-slot:item.proExpirationDate="{ item }">
              <p class="my-0">{{ item.proExpirationDate.substr(0, 10) }}</p>
            </template>
          </v-data-table>
          <v-row class="d-flex justify-center">
            <v-btn @click="closeWindow">Close</v-btn>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-overlay v-model="overlayAddBatch">
      <AddBatch :club="club" @created="createdBatch" @closeWindow="overlayAddBatch = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import AddBatch from "@/views/Clubs/components/AddBatch";

export default {
  name: "ClubBatches",
  components: {
    AddBatch
  },
  props: {
    club: Object,
  },
  data() {
    return {
      headers: [
        {text: 'ID', value: 'id', align: 'left', sortable: true, filterable: true},
        {text: 'Name', value: 'name', align: 'left', sortable: true, filterable: true},
        {text: 'Pro Expiration', value: 'proExpirationDate', align: 'left', sortable: true, filterable: true}
      ],

      overlayAddBatch: false,
    }
  },
  mounted() {},
  methods: {
    createdBatch() {
      this.overlayAddBatch = false;
      this.$emit("createdBatch");
    },
    closeWindow() {
      this.$emit("closeWindow");
    },
  },
};
</script>

<style scoped>
</style>
